DialogAddTipoUniGesCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogAddTipoUniGesCtrl($log, $scope, $http) {
    const URL_MANT_UNI_GES = Sigo.var.path + '/mantenimiento/unidad-gestion-acciones';

    var vm = this;

    vm.model = $scope.model;
    vm.model.incluir_hijos = false;

    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };
    vm.formDeshabilitado = true;
    var idUniGes = vm.model.idUniGes;


    cargarTipos();

    function cargarTipos() {
        var url = URL_MANT_UNI_GES + '/add-tipo/' + idUniGes;
        var promise = $http.get(url);
        promise.then(function (data) {
            vm.tipos = data.data;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;

            if (vm.tipos.length < 1) {
                vm.dialogHandler.cancel();
                $.toast({
                    heading: 'Advertencia',
                    text: "Ya están todos los tipos asignados a esta unidad de gestión",
                    showHideTransition: 'slide',
                    icon: 'warning'
                });
            }
        });
    }

    vm.submitTipo = submitTipo;

    function submitTipo(tipoSeleccionado) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;

        var tipoId = null;
        if (typeof tipoSeleccionado.id !== 'undefined') tipoId = tipoSeleccionado.id;

        var incluir_hijos = issetAndNotEmpty(tipoSeleccionado.tipo_padre) ? false : vm.model.incluir_hijos;

        var url = URL_MANT_UNI_GES + '/add-tipo/' + idUniGes;
        var data = {
            tipo_id: tipoId,
            incluir_hijos: incluir_hijos
        };

        var promise = $http.post(url, data);
        promise.then(function (data) {
            var respuesta = data.data.message;

            $.toast({
                text: respuesta,
                icon: 'success',
                hideAfter: 5000
            });

            vm.dialogHandler.close(data);
            //TODO: COntrolar errores
        });
    }

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}